
import { AlertCircle } from "lucide-react"

interface AIEmptyProps {
  compact?: boolean
}

export function AIEmpty({ compact = false }: AIEmptyProps) {
  return (
    <div className={`p-6 flex flex-col items-center justify-center text-center bg-gradient-to-br from-[#000808] to-[#0F1726] rounded-md shadow-md ${!compact ? 'mt-2' : ''}`}>
      <div className="bg-[#FFC745]/10 p-2 rounded-full mb-2">
        <AlertCircle className="h-6 w-6 text-[#FFC745]" />
      </div>
      <h4 className="text-sm font-medium text-[#FFC745] mb-1">No AI analysis available</h4>
      <p className="text-xs text-[#FFC745]/90 max-w-xs">
        We couldn't generate AI recommendations for this caregiver. This may happen if there isn't enough chat history or activity data.
      </p>
    </div>
  )
}
